import React, { Component } from 'react';
import './styles/descriptionMatch.scss';
import { Button } from 'src/packages/components/lib/Button';
import Utils, { showSoccerWorldCup } from 'src/utils/Utils';
import getMatchById from 'src/mundial/requests/api/getMatchById';
import Assets from 'src/requests/apa/Asset';
import {
    VERSUS,
    WATCH_NOW,
    SEPARATOR,
    HOURS,
    STADIUM,
    IStatesDescriptionMatch,
    Flag,
    getMatchId,
    INIT_MATCH,
    splitLocationOfHistory,
    IN_PROGRESS,
} from './index';
import { RouteComponentProps } from 'react-router-dom';
import { isValidGroupId } from 'src/components/Ficha/fichaHelper';
import store from 'src/store';
import { playFullMedia } from 'src/actions/playmedia';
import { sendGAEvent } from 'src/utils/analytics';
import { getApaMatchLiveButton } from 'src/mundial/utls/utils';
import Asset from 'src/requests/apa/Asset';

interface IDescriptionMatchProps {
    history: RouteComponentProps;
    location: string;
}

interface IReturnSetDataMatch {
    groupId: string | unknown;
    roundId: string | unknown;
    status: string;
}

class DescriptionMatch extends Component<IDescriptionMatchProps> {
    imageBackground: string;
    style: React.CSSProperties;
    state: IStatesDescriptionMatch;
    phaseName: string;

    constructor(props: IDescriptionMatchProps) {
        super(props);
        this.imageBackground = Assets.get('match_info_header_img');
        this.style = {
            backgroundImage: `url(${this.imageBackground})`,
        };
        this.state = INIT_MATCH;
        this.viewPlayButton = this.viewPlayButton.bind(this);
        this.getTextVS = this.getTextVS.bind(this);
        this.setDataMatch = this.setDataMatch.bind(this);
        this.handleClickPlay = this.handleClickPlay.bind(this);
    }

    handleClickPlay = (eventLabel: string) => {
        const validGroupId = isValidGroupId(this.state.group_id);
        const dataDispatchPlay = {
            playerstate: 'PLAYING',
            source: {
                videoid: this.state.group_id,
            },
            size: {
                top: 0,
                left: 0,
                width: 1280,
                height: 720,
            },
            ispreview: false,
            islive: true,
            ispip: false,
            event: null,
        };
        if (validGroupId) {
            sendGAEvent({
                hitType: 'event',
                eventCategory: 'reproductor',
                eventAction: 'mundial 2022',
                eventLabel,
            });

            store.dispatch(playFullMedia(dataDispatchPlay));
        }
    };

    viewPlayButton = (status: string): boolean => {
        const { enable, group_id } = getApaMatchLiveButton();
        const enableButton = enable && status === 'IN_PROGRESS';
        this.setState({ group_id, enableButton });

        return enableButton;
    };

    getTextVS = (): string => {
        const translate = VERSUS;
        return translate.slice(0, 2);
    };

    setDataMatch = async (matchId: string): Promise<IReturnSetDataMatch> => {
        const dataMatch = await getMatchById(matchId);
        localStorage.setItem('match', JSON.stringify(dataMatch));
        this.setState({ ...dataMatch });
        const { status, groupId, roundId } = dataMatch;
        return { status, groupId, roundId };
    };

    async componentDidMount(): Promise<void> {
        const matchId = getMatchId();
        const { status } = await this.setDataMatch(matchId);
        const splitLocation = splitLocationOfHistory(this.props.history);
        const indexTarget = splitLocation.length - 1;
        const enableButton = this.viewPlayButton(status);

        let interval: NodeJS.Timeout | unknown;
        const { interval_time } = showSoccerWorldCup();

        if (status === IN_PROGRESS) {
            interval = setInterval(async () => {
                const matchId = getMatchId();
                await this.setDataMatch(matchId);
            }, interval_time * 1000);
        }

        this.setState({ interval });

        const classFocusable = !enableButton ? '.namesTitle' : '.play-focusable';
        splitLocation[indexTarget] === matchId && (await Utils.setInitialFocus(classFocusable));
    }

    componentWillUnmount(): void {
      const { interval } = this.state;
      interval && clearInterval(interval as NodeJS.Timeout);
    }

    render() {
        const { homeTeam, awayTeam, stadium, date, enableButton } = this.state;
        const namesTitle = `${homeTeam.name} ${this.getTextVS().toLowerCase()} ${awayTeam.name}`;
        const defaultFlag = Asset.get('vcard_team_placeholder_img')
        return (
            <div id="imageBackground" style={this.style}>
                <div id="flags">
                    <div id="wrapperFlags">
                        <div id="flagLocal">
                            <Flag size="large" imageFlag={homeTeam.flag || defaultFlag} />
                        </div>
                        <div id="flagVisit">
                            <Flag size="large" imageFlag={awayTeam.flag || defaultFlag} />
                        </div>
                        <div id="textVersus">{VERSUS}</div>
                    </div>
                </div>
                <Button id="namesTitle-focusable" type="button" className="focusable namesTitle">
                    <div id="namesTitle">{namesTitle}</div>
                </Button>
                <div id="infoSubtitle">
                <span id="versusSubtitle">
                        {`${homeTeam.nameAbbrev} ${this.getTextVS().toLowerCase()} ${
                            awayTeam.nameAbbrev
                        } ${SEPARATOR} `}
                    </span>
                    <span id="locationSubtitle">
                        {`${date.hours}:${date.minutes} ${HOURS} ${STADIUM} ${stadium || ''}`}
                    </span>
                </div>
                {enableButton && (
                    <Button
                        id="play-focusable"
                        type="button"
                        className="focusable play-focusable"
                        onClick={() => this.handleClickPlay(namesTitle)}
                    >
                        <div id="button-play">
                            <img
                                id="image-play"
                                src={Assets.get('match_detail_option_button_play')}
                                alt="play"
                            />
                        </div>
                        <div id="message-play">{WATCH_NOW}</div>
                    </Button>
                )}
            </div>
        );
    }
}

export default DescriptionMatch;



// WEBPACK FOOTER //
// ./src/mundial/Vcards/VcardMatch/DescriptionMatch.tsx